import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '../../lib/i18n';
import { useKitchenPause } from '../../lib/kitchen-pause-context';
export function KitchenPausedBanner() {
  const {
    t
  } = useLanguage();
  const {
    isKitchenPaused,
    monitoredRestaurantId
  } = useKitchenPause();
  // Only render when actively monitoring a restaurant AND kitchen is paused
  if (!isKitchenPaused || !monitoredRestaurantId) return null;
  return <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-3" data-id="element-2516">
      <div className="max-w-5xl mx-auto flex items-start sm:items-center gap-3" data-id="element-2517">
        <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5 sm:mt-0" data-id="element-2518" />
        <div data-id="element-2519">
          <h3 className="text-sm font-bold text-amber-500" data-id="element-2520">
            {t('kitchen_paused')}
          </h3>
          <p className="text-sm text-amber-500/80 mt-0.5" data-id="element-2521">
            {t('kitchen_paused_msg')}
          </p>
        </div>
      </div>
    </div>;
}